import { render, staticRenderFns } from "./DriverStandings.vue?vue&type=template&id=321a5d42&scoped=true&"
import script from "./DriverStandings.vue?vue&type=script&lang=js&"
export * from "./DriverStandings.vue?vue&type=script&lang=js&"
import style0 from "./DriverStandings.vue?vue&type=style&index=0&id=321a5d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a5d42",
  null
  
)

export default component.exports